import { render, staticRenderFns } from "./AsideStatsSection.vue?vue&type=template&id=65aa75cd&"
import script from "./AsideStatsSection.vue?vue&type=script&lang=js&"
export * from "./AsideStatsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports